import { supabase } from '../lib/supabase';

// Email submission service for access control
export const emailService = {
  // Submit email for accessing financial projections
  submitEmailForAccess: async (email, source = 'rv_park_calculator') => {
    try {
      // 1. Try Supabase first
      try {
        await supabase
          .from('lead_captures')
          .insert([{ email, source, created_at: new Date() }]);
      } catch (err) {
        // Silent fail
      }

      // 2. Local Fallback (always do this to ensure user gets access)
      localStorage.setItem('rv_calculator_email_verified', email);
      localStorage.setItem('rv_calculator_access_granted', 'true');
      localStorage.setItem('rv_calculator_access_timestamp', Date.now().toString());
      
      return {
        success: true,
        message: 'Email submitted successfully',
        isExisting: false
      };
    } catch (error) {
      return {
        success: false,
        message: error?.message || 'Failed to submit email',
        isExisting: false
      };
    }
  },
  
  // Check if user has access (email submitted)
  hasAccess: () => {
    const accessGranted = localStorage.getItem('rv_calculator_access_granted');
    const email = localStorage.getItem('rv_calculator_email_verified');
    const timestamp = localStorage.getItem('rv_calculator_access_timestamp');
    
    // Check if access is valid (email exists and timestamp is within 24 hours)
    if (accessGranted === 'true' && email && timestamp) {
      const accessTime = parseInt(timestamp);
      const currentTime = Date.now();
      const hoursPassed = (currentTime - accessTime) / (1000 * 60 * 60);
      
      // Access valid for 24 hours
      return hoursPassed < 24;
    }
    
    return false;
  },
  
  // Get stored email
  getStoredEmail: () => {
    return localStorage.getItem('rv_calculator_email_verified');
  },
  
  // Clear access (for testing or logout)
  clearAccess: () => {
    localStorage.removeItem('rv_calculator_email_verified');
    localStorage.removeItem('rv_calculator_access_granted');
    localStorage.removeItem('rv_calculator_access_timestamp');
  },
  
  // Get user IP address
  getUserIP: async () => {
    try {
      const ipServiceUrl = import.meta.env.VITE_IP_SERVICE_URL || 'https://api.ipify.org?format=json';
      const response = await fetch(ipServiceUrl);
      const data = await response?.json();
      return data?.ip || null;
    } catch (error) {
      return null;
    }
  },
  
  // Save calculator session with email
  saveCalculatorSession: async (email, sessionData, calculatedResults) => {
    try {
      await supabase
        .from('calculator_sessions')
        .insert([{ 
          email, 
          session_data: sessionData, 
          results: calculatedResults,
          created_at: new Date() 
        }]);
      return { success: true };
    } catch (err) {
      console.warn('Error saving session:', err);
      return { success: false };
    }
  }
};
